import { render, staticRenderFns } from "./AccountAlertPanel.vue?vue&type=template&id=513dfcc6&scoped=true"
import script from "./AccountAlertPanel.vue?vue&type=script&lang=ts"
export * from "./AccountAlertPanel.vue?vue&type=script&lang=ts"
import style0 from "./AccountAlertPanel.vue?vue&type=style&index=0&id=513dfcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513dfcc6",
  null
  
)

export default component.exports